
<div class="container">
  <div class="col-md-12 not-auth">
    <h1> <i class="armx-user-times" style="font-size:46px"></i>{{ 'pages.unAuthourizedPage.unAuthoorizedAccess' | translate}}</h1>
  </div>
</div>

